import type { LeadNote } from '@/types';

import React from 'react';
import { Card, CardBody, Button } from '@heroui/react';
import { RiDeleteBinLine } from '@remixicon/react';

import { UserCell } from '@/components/shared/UserCell';
import { DateTimeDisplay } from '@/components/shared/DateTimeDisplay';
import { PermissionGuard } from '@/components/shared/PermissionGuard';

interface LeadNoteItemProps {
  note: LeadNote;
  onDelete: () => void;
  isDeleting?: boolean;
}

export function LeadNoteItem({ note, onDelete, isDeleting }: LeadNoteItemProps) {
  return (
    <Card>
      <CardBody className="p-4">
        <div className="flex items-start justify-between gap-4">
          <div className="flex-1 space-y-2">
            <p className="text-default-700 whitespace-pre-wrap">{note.note}</p>
            <div className="flex items-center gap-4 text-sm text-default-500">
              <UserCell user={note.user} dense />
              <DateTimeDisplay dateString={note.created_at} />
            </div>
          </div>
          <PermissionGuard permission="LeadNote.destroy">
            <Button
              isIconOnly
              size="sm"
              variant="light"
              color="danger"
              onPress={onDelete}
              isLoading={isDeleting}
            >
              <RiDeleteBinLine className="h-4 w-4" />
            </Button>
          </PermissionGuard>
        </div>
      </CardBody>
    </Card>
  );
}

